import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useLocation, useNavigate } from "react-router-dom";
import { uploadCombinedDocumentToTransformer } from "../../../../services/webServices";
import LinearProgressBar from "../../../common-components/QMentisLinearProgressBar";
import {
  LoadingModalContext,
  MessagePopupContext,
} from "../../../main-pages/ServicePage";
import LoadingModal from "../../../common-components/LoadingModal";
import { handleProgressBar } from "../../../custom-components/ProgressBar/ProgressBarWithAPI";
import SessionExpired from "../../../popup-components/SessionExpiredPopup";

const archetypeMapping = {
  SaaS: "saas",
  "Event-Driven": "eventDriven",
  "Cloud-Native": "cloudNative",
  Monolithic: "monolithic",
  Microservices: "microservices",
  "LLM-centric": "llmCentric",
};

export default function ArchetypePrefernce() {
  const [selected, setSelected] = useState([]);
  const [index, setIndex] = useState(1);
  const [loader, setLoader] = useState(false);
  const [sessionExpiredValue, setSessionExpiredValue] = useState(false);
  // const { setLoadingState } = useContext(LoadingModalContext);

  const { setMessagePopup, setMessage } = useContext(MessagePopupContext);

  const navigate = useNavigate();
  const location = useLocation();

  const handleToggle = (value) => {
    setSelected((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };
  const handleback = () => {
    if (index === 1) {
      // navigate("/dashboard/qe-strategy/archetype-predicted", {
      //   state: location.state,
      // });
      navigate(-1);
    }
  };

  // This is perfectly fine for your use case:
  const percentageMap = {};
  if (location.state?.all_architectures) {
    location.state.all_architectures.forEach((arch) => {
      percentageMap[arch.name] = arch.percentage;
    });
  }

  const archetypes = Object.entries(archetypeMapping).map(([label, value]) => ({
    label,
    value,
    percentage: percentageMap[label] || 0,
  }));

  const handleProceed = async () => {
    setLoader(true);
    // setLoadingState({ open: true, message: "Analyzing...", progress: null });
    // let progressHandler;
    // progressHandler = handleProgressBar({
    //   setLoadingState,
    //   totalDurationMs: 120000,
    // });

    if (selected.length === 0) {
      alert("Please select at least one archetype");
      setLoader(false);

      return;
    }

    const chosenArchetypes = selected;

    const archetypeHeader = chosenArchetypes
      .map((_, i) => `archetype ${i + 1}`)
      .join(",");
    const archetypeRow = chosenArchetypes.join(",");

    const uploadedCSV = location.state?.uploadedCSV;
    const uploadedLines = uploadedCSV.trim().split("\n");
    const headerLine = uploadedLines[0];
    const dataLine = uploadedLines[1];

    const initialCombinedHeader = `${headerLine},${archetypeHeader}`;
    const initialCombinedRow = `${dataLine},${archetypeRow}`;
    const initialCombinedCSV = `${initialCombinedHeader}\n${initialCombinedRow}`;

    const blob = new Blob([initialCombinedCSV], { type: "text/csv" });
    const formData = new FormData();
    formData.append("file", blob, "qe_strategy_report_full.csv");

    // Trigger download of final CSV
    const downloadLink = document.createElement("a");
    const url = URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.download = "qe_strategy_report_full.csv";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(url);

    try {
      // progressHandler.start("Analyzing...");

      const response = await uploadCombinedDocumentToTransformer(formData);

      const backendData = response.data.pillar_test_suggestions;
      const topQEpillars = response.data.qe_pillars;
      const topQEpillarsChart = response.data.visualizations?.pillars_chart;

      const qePillarConfidences = response.data.all_predictions;
      const updatedConfidences = qePillarConfidences.map((item) => ({
        ...item,
        probability: item.probability * 100,
      }));

      const pillarsPieChart = response.data.visualizations?.pillars_pie_chart;
      const individualRadarCharts =
        response.data.visualizations?.pillar_radar_base64 || {};

      // Add backend results into final CSV
      const backendColumns = [];
      const backendValues = [];

      Object.entries(backendData).forEach(([pillarName, pillarData]) => {
        backendColumns.push(pillarName);
        backendValues.push(pillarData.test_types.join(";"));
      });

      const finalHeader = `${initialCombinedHeader},${backendColumns.join(
        ","
      )}`;
      const finalRow = `${initialCombinedRow},${backendValues.join(",")}`;
      const finalCSV = `${finalHeader}\n${finalRow}`;

      const finalBlob = new Blob([finalCSV], { type: "text/csv" });
      // await progressHandler.finishAndClose();

      navigate("/dashboard/qe-strategy/advisory-layer", {
        state: {
          topQEpillars: topQEpillars,
          pillarTestSuggestions: backendData,
          backendData: backendData,
          topQEpillarsChart: topQEpillarsChart,
          pillarsPieChart: pillarsPieChart,
          individualRadarCharts: individualRadarCharts,
          finalCSV: finalCSV,
          initialCombinedCSV: initialCombinedCSV,
          updatedConfidences: updatedConfidences,
        },
      });
    } catch (error) {
      console.error("Full error:", error);
      console.error("Error response:", error.response);
      setLoader(false);
      // progressHandler.stop();

      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Unknown error occurred";

      setMessage(errorMessage);
      setMessagePopup(true);

      if (errorMessage === "Your session has expired.") {
        setSessionExpiredValue(true);
      }
    }
  };

  return (
    <Box sx={{ p: 4, bgcolor: "#f9f7f6", minHeight: "100vh" }}>
      {" "}
      <Typography variant="h6" gutterBottom>
        Human in the loop Suggested Archetypes{" "}
      </Typography>
      {/* Checkboxes in Grid2 */}
      <Grid container spacing={2} sx={{ mb: 4 }}>
        {archetypes.map((item) => (
          <Grid size={{ xs: 12, sm: 6 }} key={item.value}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                borderRadius: 1,
                bgcolor: "white",
                // boxShadow: 1,
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selected.includes(item.value)}
                    onChange={() => handleToggle(item.value)}
                  />
                }
                label={item.label}
              />
              <Typography
                sx={{ color: "#0094FB", fontWeight: 200, fontSize: 13 }}
                variant="body2"
                color="primary"
              >
                ({item.percentage.toFixed(2)}%)
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
      {/* Footer Buttons */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 4,
        }}
      >
        <Button
          onClick={handleback}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            borderWidth: 2,
            borderColor: "#0094FB",
            height: 35,
            fontWeight: 600,
          }}
          variant="outlined"
          startIcon={<ArrowBackIcon />}
        >
          Back
        </Button>
        <Button
          sx={{
            bgcolor: "#0094FB",
            borderRadius: "8px",
            textTransform: "none",
            borderColor: "#0094FB",
            height: 35,
          }}
          variant="contained"
          onClick={handleProceed}
          endIcon={<ArrowForwardIcon />}
        >
          Proceed
        </Button>
      </Box>
      {loader && <LinearProgressBar label={"Analyzing..."} />}
      {sessionExpiredValue && <SessionExpired />}
    </Box>
  );
}
